var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"card"},[_c('div',{staticClass:"title"},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('tooltip',{attrs:{"text":_vm.tooltip}}),(_vm.helpContent)?_c('helpIcon',{attrs:{"content":_vm.helpContent}}):_vm._e()],1),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }